<template>
  <v-app id="vuetify-app">
    <v-container fluid>
      <v-flex xs12>
        <education-manage-modal ref="educationModal" :routes="routes" :videos="videos" :roles="roles" />
      </v-flex>
      <v-flex xs12>
        <education-table @editEducation="editEducation" />
      </v-flex>
    </v-container>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    routes: Object,
    videos: Array,
    roles: Array,
  },
  created() {
    this.fetchEducation();
  },
  methods: {
    ...mapActions(['fetchEducation']),
    editEducation(education) {
      this.$refs.educationModal.openAndEdit(education);
    },
  },
};
</script>

<style scoped></style>
